import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, Plus } from "lucide-react";

interface DropdownButton {
  label: string;
  onClick: () => void;
}

interface ClickMenuDropdownProps {
  dropdownLabel: string;
  buttons: DropdownButton[];
}

const ClickMenuDropdown: React.FC<ClickMenuDropdownProps> = ({
  dropdownLabel,
  buttons,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex items-center justify-center gap-2 rounded-[8px] border border-[#E5E5E5] bg-white px-3 py-2 shadow-[0_1px_2px_rgba(0,0,0,0.05)]"
      >
        <Plus size={16} strokeWidth={2} className="text-[#0A0A0A]" />

        <span className="text-[12px] font-medium leading-4 text-[#0A0A0A]">
          {dropdownLabel}
        </span>

        <ChevronDown size={16} className="text-[#737373]" />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full z-20 mt-1 min-w-[120px] w-max rounded-[8px] border border-[#E5E5E5] bg-white p-1 shadow-[0_1px_2px_rgba(0,0,0,0.05)]">
          {buttons.map((btn, index) => (
            <button
              key={index}
              onClick={() => {
                setIsOpen(false);
                btn.onClick();
              }}
              className="flex w-full items-center whitespace-nowrap rounded-[6px] px-2 py-[6px] text-left text-[14px] font-normal leading-5 text-[#0A0A0A] hover:bg-[#F5F5F5]"
            >
              {btn.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClickMenuDropdown;